var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackAccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,2 C11.0273574,2 12.0384153,2.15809015 13.0006499,2.46079865 L13.0009677,4.58190884 C12.0742738,4.20665097 11.0612698,4 10,4 C5.581722,4 2,7.581722 2,12 C2,16.418278 5.581722,20 10,20 C12.1217319,20 14.1565632,19.1571453 15.6568542,17.6568542 C17.1571453,16.1565632 18,14.1217319 18,12 C18,10.9391108 17.7934972,9.92645293 17.4184949,9.0000295 L19.5395164,9.00035178 C19.8420195,9.96228631 20,10.972999 20,12 C20,17.5228475 15.5228475,22 10,22 C4.4771525,22 0,17.5228475 0,12 C0,6.4771525 4.4771525,2 10,2 Z",
    id: "Combined-Shape",
    fill: "#333B47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.924,15 C7.4652844,15.5922768 8.60519266,16 9.924,16 C11.2428073,16 12.3827156,15.5922768 12.924,15",
    id: "Stroke-1",
    stroke: "#333B47",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(9.924000, 15.500000) scale(-1, 1) translate(-9.924000, -15.500000) "
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#333B47",
    cx: 7,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-15",
    fill: "#333B47",
    cx: 13,
    cy: 10,
    r: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "LUI-icon-pd-add-solid-16",
    transform: "translate(14.000000, 0.000000)",
    fill: "#0BC7C2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    points: "8 5 5 5 5 8 3 8 3 5 0 5 0 3 3 3 3 0 5 0 5 3 8 3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackAccess);
export default __webpack_public_path__ + "static/media/feedback-access.9a3462ce407f0dbc1349f1063fd16516.svg";
export { ForwardRef as ReactComponent };